// @flow

export const POST_DATA_LOAD = 'POST_DATA_LOAD'
export const POST_DATA_RESET = 'POST_DATA_RESET'
export const POST_FILES_UPDATE = 'POST_FILES_UPDATE'
